import BaseModel from "../../core/components/input-widget/BaseModel";
import {getFilenameRuleObj} from "@/plugins/vee-validate";
import i18n from "@/shared/i18n";

export default class ContractFileModel extends BaseModel {
  name = null;
  comment = null
  fileObj = null

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    name: getFilenameRuleObj(true),
    comment: 'max:255'
  };

  attributeHints = {
  };

  attributeLabels = {
    comment: i18n.t('Comment')
  };
}
